<template>
  <g>
    <g clip-path="url(#clip0_15_430)">
      <path
        d="M5.5 21.0002V14.5002H5C4.45 14.5002 4 14.0502 4 13.5002V9.00024C4 7.90024 4.9 7.00024 6 7.00024H9C10.1 7.00024 11 7.90024 11 9.00024V13.5002C11 14.0502 10.55 14.5002 10 14.5002H9.5V21.0002C9.5 21.5502 9.05 22.0002 8.5 22.0002H6.5C5.95 22.0002 5.5 21.5502 5.5 21.0002ZM18 21.0002V16.0002H19.61C20.29 16.0002 20.77 15.3302 20.56 14.6802L18.46 8.37024C18.18 7.55024 17.42 7.00024 16.56 7.00024H16.44C15.58 7.00024 14.81 7.55024 14.54 8.37024L12.44 14.6802C12.22 15.3302 12.7 16.0002 13.39 16.0002H15V21.0002C15 21.5502 15.45 22.0002 16 22.0002H17C17.55 22.0002 18 21.5502 18 21.0002ZM7.5 6.00024C8.61 6.00024 9.5 5.11024 9.5 4.00024C9.5 2.89024 8.61 2.00024 7.5 2.00024C6.39 2.00024 5.5 2.89024 5.5 4.00024C5.5 5.11024 6.39 6.00024 7.5 6.00024ZM16.5 6.00024C17.61 6.00024 18.5 5.11024 18.5 4.00024C18.5 2.89024 17.61 2.00024 16.5 2.00024C15.39 2.00024 14.5 2.89024 14.5 4.00024C14.5 5.11024 15.39 6.00024 16.5 6.00024Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_430">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
